export const TripStatus = {
    NOT_PUBLISHED : 1,
    PUBLISHED_AS_PLANNED : 2,
    PUBLISHED : 3,
    INTERNAL_NOT_READY : 4,
    INTERNAL_READY : 5,
};